// libs
import dayjs from 'dayjs';
import { DateRangeEnum } from '@/stores/defs/metrics';
export const INITIAL_STATE = {
    aggregateMetrics: undefined,
    campaignPerformance: {
        selectedRange: {
            type: DateRangeEnum.LAST_WEEK,
            range: {
                startTime: dayjs().subtract(7, 'day').toISOString(),
                endTime: dayjs().subtract(1, 'day').toISOString(),
            },
        },
        data: [],
    },
};
